import { Grid as ChakraGrid, GridProps as ChakraGridProps } from '@chakra-ui/react';
import React from 'react';

export function Grid(props: ChakraGridProps) {
  return <ChakraGrid templateColumns="repeat(12, 1fr)" {...props} />;
}
